module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h2', {
    staticClass: "u"
  }, [_vm._v("Клиенты "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'client-add'
      }
    }
  }, [_vm._v("+ Добавить клиента")])], 1), _vm._v(" "), _c('resource-list', {
    attrs: {
      "url": "/clients",
      "current-sort": "contract_number",
      "init-sort-type": "asc",
      "resource-name": "clients",
      "show-per-page": false,
      "action-routes": _vm.actionRoutes,
      "fields": _vm.fields,
      "filters": _vm.filters
    },
    on: {
      "total": _vm.updateTotal,
      "first-id": _vm.updateClientId
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33af7356","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/Clients.vue
// module id = 619
// module chunks = 0